import Login from "./pages/Login.vue"
import Main from "./pages/Main.vue"
import Room from "./pages/Room.vue"
import Select from "./pages/SelectTime.vue"
import SearchEndTime from "./pages/SearchEndTime.vue"
import SearchCriteria from "./pages/SearchCriteria.vue"
import Result from "./pages/SearchResults.vue"
import Booking from "./pages/Booking.vue"
import Other from "./pages/Other.vue"
import DisplayError from "./pages/Error.vue"

export default [
  {
    path: "/login",
    component: Login
  },
  {
    path: "/main",
    component: Main
  },
  {
    path: "/room/:roomId",
    component: Room
  },
  {
    path: "/select/:roomId",
    component: Select
  },
  {
    path: "/criteria",
    component: SearchCriteria
  },
  {
    path: "/time",
    component: SearchEndTime
  },
  {
    path: "/result",
    component: Result
  },
  {
    path: "/booking/:roomId",
    component: Booking
  },
  {
    path: "/other",
    component: Other
  },
  {
    path: "/error",
    component: DisplayError
  }
];
